import React from 'react';
import { Button } from 'antd';
import { DeleteTwoTone } from '@ant-design/icons';
import { ButtonProps } from 'antd/lib/button';

export type DeleteButtonProps = ButtonProps & {
  onlyIcon?: boolean;
  custom?: React.CSSProperties;
};

const DeleteButton = ({
  children = 'Delete',
  onlyIcon = false,
  icon,
  custom,
  ...otherProps
}: DeleteButtonProps) => {
  return (
    <Button
      icon={icon??<DeleteTwoTone twoToneColor="#eb2f96" />}
      style={custom??{
        height: 40,
        width: onlyIcon?40:'auto',
        marginLeft: 5,
        marginRight: 5,
      }}
      {...otherProps}
    >
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default DeleteButton;
